import {
  AgCheckBoxEditor,
  AgPercentEditor,
} from '../components/ag-cell/ag-cell.component';
import { Injectable, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import {
  ApplyColumnStateParams,
  ColDef,
  ColumnState,
  GridApi,
  RowSelectionOptions,
  StatusPanelDef,
  themeQuartz,
  type Theme,
} from 'ag-grid-community';
import {
  AgTextAreaEditor,
  BtnDeleteCellRendererComponent,
  BtnEditCellRendererComponent,
} from '../components/ag-cell/ag-cell.component';
import { idNameItem, CR, PageKind } from './jkInterface'; // PageType,
import { jkLib } from './jkCommon';
import { AG_GRID_LOCALE_ZH_TW } from './ag-grid-locale.zh-TW';
import { PageService } from './page.service';

export const agGridCompare: idNameItem[] = [
  { id: 'greatThen', name: '大於等於', ps1: ' >= ' },
  { id: 'lessThen', name: '小於等於', ps1: ' <= ' },
  { id: 'equal', name: '等於', ps1: ' = ' },
  { id: 'like', name: '前包含', ps1: ' like ' },
  { id: 'like2', name: '其中包含', ps1: ' like ' },
];

export function numberFormatter(params: any) {
  if (params.value === null || params.value === undefined) {
    return '';
  }
  return Number(params.value).toLocaleString(); // 根據你的需求來格式化數字
}
export function dateFormatter(params: any) {
  return jkLib.dateField2Display(params.value);
}
export function datetimeFormatter(params: any) {
  return jkLib.datetimeFormatter(params.value);
}

export function time5Formatter(params: any) {
  let mStr = jkLib.fixString(params.value);
  try {
    mStr = mStr.substring(0, 2) + ':' + mStr.substring(2, 4);
  } catch (error) {
    mStr = params;
  }
  return mStr;
}
export function time8Formatter(params: any) {
  let mStr = jkLib.fixString(params.value);
  try {
    mStr = mStr.substring(0, 2) + ':' + mStr.substring(2, 4) + ':' + mStr.substring(4, 6);
  } catch (error) {
    mStr = params;
  }
  return mStr;
}
export function percentageFormatter1(params: any): string {
  if (params.value == null) {
    return '';
  }
  return `${(params.value * 100).toFixed(1)}%`;
}

export function percentageFormatter2(params: any): string {
  if (params.value == null) {
    return '';
  }
  return `${(params.value * 100).toFixed(2)}%`;
}

export const openwinColdef: ColDef = {
  editable: false,
  wrapHeaderText: true,
  autoHeaderHeight: true,
  autoHeight: true,
  wrapText: false,
  //flex: 1,
  minWidth: 10,
  width: 250,
  maxWidth: 750, // 250:約60字
  // checkboxSelection: true, 改用 rowSelection
  sortable: true,
  filter: true,
};

export enum gridSortType {
  '',
  'asc',
  'desc',
};

export interface GridInitOption {
  programId: string;
  //pageType: PageType;
  pageKind: PageKind;
  sortField: string;
  sort: 'asc' | 'desc' | ''; // gridSortType
  defaultSort: 'asc' | 'desc' | null;
}
export interface ColumnModi {
  index?: number;
  field: string;
  headerName: string;
  width: number;
  hide?: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class AgGridService {
  private page = inject(PageService);


  gridInitOpt: GridInitOption = {
    pageKind: PageKind.base,
    programId: '',
    sortField: '',
    sort: 'asc',
    defaultSort: null
  };
  gridApi!: GridApi;
  programId: string = '';
  rowIndex: number | null = null; // 由 agRowClicked 回饋
  sortField: string = '';
  colDefs: ColDef[] = [];
  fieldLengths: any; // 20250210 add
  sort: 'asc' | 'desc' | '' = 'asc';
  defaultSort: 'asc' | 'desc' | null = null;

  pagination = false;
  paginationPageSize = 100;
  paginationPageSizeSelector: number[] | boolean = [5, 10, 100, 200, 300];
  public theme: Theme = themeQuartz.withParams({
    fontSize: 16,
    spacing: 4,
    iconSize: 12,
  });
  rowClassRules = {
    // apply red to Ford cars
    'rag-red': (params: any) => params.data.WD018 === '一',
  };
  public localeText: {
    [key: string]: string;
  } = AG_GRID_LOCALE_ZH_TW;
  public defaultColDef: ColDef = openwinColdef;
  /*
  {
    editable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    autoHeight: true,
    wrapText: false,
    //flex: 1,
    minWidth: 10,
    maxWidth: 750,
    sortable: true,
    filter: true,
  };*/
  columnTypes = {
    nonEditableColumn: { editable: false },
    dateColumn: {
      filter: 'agDateColumnFilter',
      filterParams: { comparator: this.myDateComparator },
      suppressHeaderMenuButton: true,
    },
    currency: {
      width: 150,
      valueFormatter: 'currencyFormatter',
    },
  };

  agEditColumnDef = {
    sortable: false,
    filter: false,
    colId: 'btnEdit',
    width: 55,
    headerName: '修',
    cellRenderer: BtnEditCellRendererComponent,
    field: 'btnEdit',
    hide: false,
    //onCellClicked: this.agEdit.bind(this),
  };
  agDeleteColumnDef = {
    sortable: false,
    filter: false,
    headerName: '刪',
    cellRenderer: BtnDeleteCellRendererComponent,
    colId: 'btnDelete',
    width: 55,
    //onCellClicked: this.agDelete.bind(this),
  };
  pageKind: PageKind = PageKind.base;

  myDateComparator(date1: Date, date2: Date) { }
  // define a column type (you can define as many as you like)
  public statusBar: {
    statusPanels: StatusPanelDef[];
  } = {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
        { statusPanel: 'agAggregationComponent' },
      ],
    };
  reloadGrid() {
    this.resort();
    //this.ag.api.redrawRows();
    if (!this.gridApi) {
      this.page.showAlert(
        'agGridService.reloadGrid gridApi is null.未執行ag.init()'
      );
      return;
    }
    this.gridApi.redrawRows();
  }
  refresh() {
    if (!this.gridApi) {
      this.page.showAlert('agGridService.refresh gridApi is null.未執行ag.init()');
      return;
    }
    this.gridApi.redrawRows();
  }

  // Enterprise feature - commented out for Community version
  // public rowGroupPanelShow: 'always' | 'onlyWhenGrouping' | 'never' = 'always';
  //public rowSelection: RowSelectionOptions<any> | 'single' | 'multiple' | undefined = {mode:'singleRow',checkboxes:false,hideDisabledCheckboxes:false}; // 'single' | 'multiple' = 'single';
  public rowSelection: RowSelectionOptions<any> = {
    mode: 'singleRow',
    checkboxes: false,
    hideDisabledCheckboxes: false,
  }; // 'single' | 'multiple' = 'single';
  public gridStyle: Record<string, string | number> = {
    width: '100%',
    height: '450px',
    //flex: '1 1 auto',
  };
  //public rowData!: IOlympicData[];
  /** 管理欄位 columnDefs
   * COMPANY,CREATOR,USR_GROUP,CREATE_DATE,MODIFIER,MODI_DATE,FLAG
   */
  managerFieldColDefs: ColDef[] = [
    {
      field: 'COMPANY',
      headerName: '資料庫代號',
      hide: true,
      width: 102,
      cellDataType: 'text',
    },
    {
      field: 'CREATOR',
      headerName: '建檔者',
      hide: true,
      width: 102,
      cellDataType: 'text',
    },
    {
      field: 'USR_GROUP',
      headerName: '群組',
      hide: true,
      width: 102,
      cellDataType: 'text',
    },
    {
      field: 'CREATE_DATE',
      headerName: '建檔日期',
      hide: true,
      width: 102,
      cellDataType: 'text',
    },
    {
      field: 'MODIFIER',
      headerName: '修改者',
      hide: true,
      width: 102,
      cellDataType: 'text',
    },
    {
      field: 'MODI_DATE',
      headerName: '修改日期',
      hide: true,
      width: 102,
      cellDataType: 'text',
    },
    {
      field: 'FLAG',
      headerName: '次數',
      hide: true,
      width: 102,
      cellDataType: 'number',
    },
  ];
  init(opt: GridInitOption) {
    this.programId = opt.programId;
    if (!this.gridApi) {
      alert('ag-grid service gridApi is null.');
      return;
    }

    //api.setGridOption('rowHeight', 50); // 設定列高
    let paginationPageSize = this.gridApi.getGridOption('paginationPageSize');
    this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize); // 在 pagination 之前
    let pagination = this.gridApi.getGridOption('pagination');
    this.gridApi.setGridOption('pagination', this.pagination); // 會報錯 The paginationPageSize grid option is set to a value that is not in the list of page size options
    //this.gridApi.setGridOption('class',this.themeClass);
    //                   paginationPageSizeSelector
    // this.gridApi.setGridOption('paginationPageSizeSelector',this.paginationPageSizeSelector);
    //this.gridApi.updateGridOptions();
    //this.gridApi.setGridOption('localeText',this.localeText);
    this.gridApi.setGridOption('defaultColDef', this.defaultColDef);
    // this.gridApi.setGridOption('statusBar',this.statusBar); enterprise only
    // this.gridApi.setGridOption('rowGroupPanelShow', this.rowGroupPanelShow); // enterprise only
    this.gridApi.setGridOption('rowSelection', this.rowSelection);
    // this.gridApi.setGridOption('sideBar', { toolPanels: ['columns'] }); // enterprise only
    //let opt = this.gridApi.getGridOption('rowHeight'); undefined
    //let rowClass = this.gridApi.getGridOption('rowClass'); undefined
    this.gridApi.setGridOption('tooltipShowDelay', 1); // jackie 20250210 add
    let bool = this.gridApi.getGridOption('enableBrowserTooltips'); // jackie 20250210 add

    this.setSort(opt.pageKind, opt.sortField, opt.sort, opt.defaultSort);
    this.resort();
    // this.agGrid.LicenseManager.setLicenseKey("Jacky_Tsai_1Devs_Company_1Devs_SingleApp_28_August_2022__MTYzMDYwNDAwMDAwMA==e3b3f3f3f3f3f3f3f3f3f3f3f3f3f3f3");
    //ag.api.sizeColumnsToFit();
  }
  setSort(
    pageKind: PageKind,
    sortField: string,
    sort: 'asc' | 'desc' | '' = 'asc',
    defaultSort: 'asc' | 'desc' | null = null
  ) {
    this.pageKind = pageKind;
    this.sortField = sortField;
    this.sort = sort;
    this.defaultSort = defaultSort;
  }
  sortBy(
    gridApi: GridApi,
    field: string,
    sort: 'asc' | 'desc' | null = 'asc',
    defaultSort: 'asc' | 'desc' | null = null
  ) {
    // "asc" | "desc"
    //let st: ColumnState;
    let param: ApplyColumnStateParams = {
      state: [{ colId: field, sort: sort }], // { colId: "WD002", sort: "desc" }
      defaultState: { sort: defaultSort }, // sort: null
    };
    gridApi.applyColumnState(param);
  }
  resort() {
    if (this.sortField === '') {
      if (
        this.pageKind === PageKind.bill
      ) {
        this.page.showAlert(
          'sortField 空白.未執行this.gridInitOpt 或 gridSrv.init()'
        );
      }
      return;
    }
    if (this.sort === '') {
      this.sort = 'asc';
    }
    let param: ApplyColumnStateParams = {
      state: [{ colId: this.sortField, sort: this.sort }], // { colId: "WD002", sort: "desc" }
      defaultState: { sort: this.defaultSort }, // sort: null
    };
    this.gridApi.applyColumnState(param);
  }
  insert(item: any) {
    return this.gridApi.applyTransaction({ add: [item] });
  }
  update(item: any) {
    return this.gridApi.applyTransaction({ update: [item] });
  }
  async delete(item: any): Promise<boolean> {
    let bool = false;
    //let node = this.gridApi.getRowNode(id);
    let r = this.gridApi.applyTransaction({ remove: [item] });
    if (r?.remove.length === 1) {
      await this.page.showToast('grid刪除成功');
      bool = true;
    } else {
      //this.refresh();
      this.reloadGrid();
    }
    return bool;
  }
  selectedItem(): any[] {
    return this.gridApi.getSelectedRows();
  }
  onBtPrint(hashTag: string, cdr: ChangeDetectorRef) {
    this.setPrinterFriendly(this.gridApi, hashTag);
    setTimeout(() => {
      print();
      this.setNormal(this.gridApi, hashTag);
      // 手動觸發變更檢測以符合 zoneless 模式
      cdr.markForCheck();
    }, 2000);
  }
  setPrinterFriendly(api: GridApi, hashTag: string) {
    const eGridDiv = document.querySelector<HTMLElement>(hashTag)! as any;
    eGridDiv.style.width = '';
    eGridDiv.style.height = '';
    api.setGridOption('domLayout', 'print');
  }
  setNormal(api: GridApi, hashTag: string) {
    const eGridDiv = document.querySelector<HTMLElement>(hashTag)! as any;
    eGridDiv.style.width = '700px';
    eGridDiv.style.height = '200px';
    api.setGridOption('domLayout', undefined);
  }
  /**
   * 存欄位設定
   */
  async doSaveTitle(colDef: ColDef[]) {
    if (this.programId === '') {
      this.page.showAlert('programId 未設定');
      return;
    }
    let colState: ColumnState[] = this.gridApi.getColumnState();

    let defModi: ColumnModi[] = [];
    if (colDef.length > 0 && colState.length > 0) {
      for (let i = 0; i < colState.length; i++) {
        let item = colDef.find((o: ColDef) => {
          return o.field === colState[i].colId;
        });
        if (!item) {
          continue;
        }
        let itemModi: ColumnModi = {
          index: i,
          field: jkLib.fixString(item.field),
          headerName: jkLib.fixString(item.headerName),
          width: jkLib.fixNumber(item.width),
          hide: item.hide as any,
          //sort:jkLib.fixString(item.sort),
          //wrapText:item.wrapText
        };
        defModi.push(itemModi);
      }
    }
    let colStateStr = JSON.stringify(defModi);
    localStorage.setItem(this.programId + '-grid', colStateStr);
  }
  /**
   * 讀欄位設定
   */
  doLoadTitle(colModi: ColumnModi[]) {
    if (this.programId === '') {
      this.page.showAlert('programId 未設定');
    }
    let colStateStr = localStorage.getItem(this.programId + '-grid');
    if (colStateStr) {
      colModi.length = 0;
      let ary = JSON.parse(colStateStr);
      colModi.push(...ary);
    }
  }
  /** 重設欄位設定
   * @param {string} programId
   */
  doResetTitle() {
    localStorage.removeItem(this.programId + '-grid');
    this.gridApi.resetColumnState();
  }
  /**
   * 顯示管理欄位
   */
  doShowManagerField(cols: ColDef[]) {
    cols.forEach((col) => {
      if (
        col.field === 'COMPANY' ||
        col.field === 'CREATOR' ||
        col.field === 'USR_GROUP' ||
        col.field === 'CREATE_DATE' ||
        col.field === 'MODIFIER' ||
        col.field === 'MODI_DATE' ||
        col.field === 'FLAG'
      ) {
        col.hide = !col.hide;
      }
    });
    this.gridApi.updateGridOptions({ columnDefs: cols });
  }
  setNumberColumns(cols: ColDef[]) {
    cols.forEach((col) => {
      if (col.cellDataType === 'number') {
        this.setNumberCol(col);
      }
    });

  }
  setNumberCol(col: ColDef) {
    col.valueFormatter = numberFormatter;
    col.cellStyle = { 'text-align': 'right' };
  }
  sortColumn(cols: ColDef[], colModi: ColumnModi[], sortFields: string) {
    let cols2: ColDef[] = [];
    /*if (colModi.length === 0) {
      this.setNumberColumns(cols);
      this.gridApi.updateGridOptions({ columnDefs: cols });
      return cols;
    }*/
    for (let i = 0; i < colModi.length; i++) {
      let item = colModi[i];
      let col = cols.find((x) => x.field === item.field);
      if (col) {
        //col.index = item.index;
        col.headerName = item.headerName;
        col.width = item.width;
        cols2.push(col);
      }
    }
    //cols.length = 0;
    cols.push(...cols2);
    if (sortFields && sortFields !== '') {
      // cols[].field 依照 sortFields 排序
      cols = this.sortByFieldList(cols, sortFields);
    };
    this.colDefs.length = 0;
    this.colDefs.push(...cols);
    this.gridApi.updateGridOptions({ columnDefs: cols });
    //this.focusFirstRow();
    return cols;
  }
  /**
   *
   * @param cols
   * @param sortFields
   * @returns
   */
  sortByFieldList(cols: ColDef[], sortFields: string): ColDef[] {
    let sortedCols: ColDef[] = [];
    let unsortedCols: ColDef[] = [];
    let fields = sortFields.split(',');
    let fieldsArray = fields.map(f => f.trim());

    // 根據 sortFields 中的順序排序 ColDef
    for (let field of fieldsArray) {
      let col = cols.find(c => c.field === field);
      if (col) {
        sortedCols.push(col);
      }
    }

    // 將未在 sortFields 中指定的 ColDef 加入 unsortedCols
    for (let col of cols) {
      if (col.field && !fieldsArray.includes(col.field)) {
        unsortedCols.push(col);
      }
    }

    // 合併排序後的列和未排序的列
    return sortedCols.concat(unsortedCols);
  }
  // 聚焦第一列
  focusFirstRow() {
    if (this.gridApi) {
      const firstRowNode = this.gridApi.getDisplayedRowAtIndex(0);
      if (firstRowNode) {
        let name = '';
        let obj = firstRowNode.data;
        name = Object.keys(obj)[0];
        if (name) this.gridApi.setFocusedCell(0, name);
        //this.gridApi.setFocusedCell(0, firstRowNode.columnApi.getAllDisplayedColumns()[0]);
      }
    }
  }

  // 聚焦下一列
  focusNextRow() {
    if (this.gridApi) {
      let focusedCell = this.gridApi.getFocusedCell();
      if (!focusedCell) {
        this.focusFirstRow();
        focusedCell = this.gridApi.getFocusedCell();
      }
      if (focusedCell) {
        const nextRowIndex = focusedCell.rowIndex + 1;
        const nextRowNode = this.gridApi.getDisplayedRowAtIndex(nextRowIndex);
        if (nextRowNode) {
          this.gridApi.setFocusedCell(nextRowIndex, focusedCell.column);
        }
      }
    }
  }
  focusPreviousRow() {
    if (this.gridApi) {
      let focusedCell = this.gridApi.getFocusedCell();
      if (!focusedCell) {
        this.focusFirstRow();
        focusedCell = this.gridApi.getFocusedCell();
      }
      if (focusedCell) {
        if (focusedCell.rowIndex > 0) {
          const nextRowIndex = focusedCell.rowIndex - 1;
          const nextRowNode = this.gridApi.getDisplayedRowAtIndex(nextRowIndex);
          if (nextRowNode) {
            this.gridApi.setFocusedCell(nextRowIndex, focusedCell.column);
          }
        }
      }
    }
  }
  // 取得目前聚焦的列在資料中的索引
  getFocusedRowIndex(): number | null {
    const focusedCell = this.gridApi.getFocusedCell();
    if (focusedCell) {
      return focusedCell.rowIndex;
    }
    return null;
  }
  // 取得目前聚焦的列的資料
  getFocusedRowData(): any {
    const focusedCell = this.gridApi.getFocusedCell();
    if (focusedCell) {
      const focusedRowNode = this.gridApi.getDisplayedRowAtIndex(
        focusedCell.rowIndex
      );
      if (focusedRowNode) return focusedRowNode.data;
      else return null;
    }
    return null;
  }
  geneColumnListDisplay(
    colDefs: ColDef[],
    labelList: string[],
    fontSize: number,
    //isMultiple: boolean
  ): ColDef[] {
    let cols: ColDef[] = [];
    for (let i = 0; i < labelList.length; i++) {
      let fieldNo = jkLib.getToken(labelList[i], ',', 1);
      let fieldName = jkLib.getToken(labelList[i], ',', 2);
      let width = 150;
      if (fieldNo === '' || fieldNo === undefined) continue;
      let col: ColDef = { field: fieldNo, headerName: fieldName, width: width };

      let colTmp = colDefs.find((x) => x.field === fieldNo);
      if (colTmp) col = colTmp;
      if (this.setColumnDisplay(col, labelList[i], fontSize)) cols.push(col);
    }
    // 加入未設定的欄位
    for (let i = 0; i < colDefs.length; i++) {
      let col = colDefs[i];
      if (cols.find((x) => x.field === col.field)) continue;
      // cellClass 設成 深灰色
      col.cellClass = 'ag-cell-gray';
      cols.push(col);
    }
    /*if (cols.length > 0) {
      let col = cols[0];
      if (isMultiple) {
        //{ mode: 'multiple', showCheckBoxesMode: 'always' };
        this.gridApi.setGridOption('rowSelection', {
          mode: 'multiRow',
          checkboxes: true,
          headerCheckbox: true,
          hideDisabledCheckboxes: true,
        });
      } else {
        this.gridApi.setGridOption('rowSelection', {
          mode: 'singleRow',
          checkboxes: false,
          hideDisabledCheckboxes: false,
        });
      }
    }*/
    return cols;
  }
  setColumnDisplay(
    col: ColDef,
    displayParam: string,
    fontSize: number
  ): boolean {
    let bool = true;
    let minWidth = 50;
    let field = jkLib.getToken(displayParam, ',', 1);
    let fieldName = jkLib.getToken(displayParam, ',', 2);
    let temp = Number(jkLib.getToken(displayParam, ',', 3));
    let format = jkLib.fixString(jkLib.getToken(displayParam, ',', 4));
    let param5 = jkLib.fixString(jkLib.getToken(displayParam, ',', 5));
    if (temp > 100) temp = 100;
    if (temp < 1) temp = 8;
    let width = temp * fontSize;
    if (width < minWidth) width = minWidth;
    col.width = width;
    col.field = field;
    col.headerName = fieldName;
    if (col.headerName === '') {
      bool = false;
      return bool;
    }
    //let col: ColDef = { field: field, headerName: fieldName, width: width };
    // TODO: format: 備註 單別 單號 序號 日期 年月 年 時間4 時間5 時間8 確認碼 整數 浮點數 % YN 字串 品號 ntext Date
    if (format === '備註') {
      col.cellRenderer = AgTextAreaEditor;
      /*col.tooltipValueGetter =  (params) => {
        return `
          <div>
            <strong>詳細描述：</strong><br>
            ${params.value}
          </div>
        `;
      };
      if(col.tooltipComponentParams)
        col.tooltipComponentParams.enableHtml= true; // 啟用 HTML 格式
      */
    }
    if (format === '單別') {
      col.width = 80;
    }
    if (format === '單號') {
      col.width = 180;
    }
    if (format === '序號') {
      col.width = 80;
    }

    if (
      (col.headerName && col.headerName.indexOf('日期') > 0) ||
      format === '日期'
    ) {
      col.width = 120;
      col.valueFormatter = dateFormatter; // (p: any) => {     return jkLib.dateField2Display(p.value);       };
    }
    // 時間4 時間5 時間8 確認碼 整數 浮點數
    if (format === '時間4') {
      col.width = 80;
      col.valueFormatter = time5Formatter;
    }
    if (format === '時間5') {
      col.width = 100;
      //col.valueFormatter = time5Formatter;
    }
    if (format === '時間8') {// 13:30:59
      col.width = 120;
      col.valueFormatter = time8Formatter;
    }
    if (format === '確認碼') {
      col.width = 60;
    }
    if (format === '整數') {
      if (col.width < 50) col.width = 50;
    }
    if (format === '浮點數') {
      if (col.width < 50) col.width = 50;
    }
    if (format === 'YN') {
      col.cellRenderer = AgCheckBoxEditor;
      if (col.width < 50) col.width = 50;
    }
    if (format === 'datetime') {
      col.valueFormatter = datetimeFormatter;// (p: any) => {        return jkLib.datetimeFormatter(p.value);      };
      col.width = 200;
    }
    if (format === 'Date') {
      //col.cellDataType = 'dateString';
      col.valueFormatter = datetimeFormatter;
      col.width = 200;
    }
    if (format === 'number' || format === '浮點數' || format === '整數') {
      col.cellDataType = 'number';
      //col.valueFormatter = numberFormatter;
      //col.cellStyle = { 'text-align': 'right' };
      this.setNumberCol(col);
    }
    if (format === '%') {
      col.cellRenderer = AgPercentEditor;
    }
    if (format === 'string') {
      col.cellDataType = 'string';
    }
    if (format === 'date10') {
      col.cellDataType = 'string';
      col.valueFormatter = dateFormatter;
    }
    if (format === 'time5') {
      col.cellDataType = 'string';
      col.valueFormatter = time5Formatter;
    }
    //colTemp.push(col);
    return bool;
  }
  setRowSelectionOpt(value: boolean) {
    if (value) {
      this.rowSelection = {
        mode: 'multiRow',
        checkboxes: true,
        headerCheckbox: true,
        hideDisabledCheckboxes: true,
      };
    } else {
      this.rowSelection = {
        mode: 'singleRow',
        checkboxes: false,
        hideDisabledCheckboxes: false,
      };
    }
    if (this.gridApi) {
      //this.gridApi.setGridOption('rowSelection', this.rowSelection);
    }
  }
  goLastRow() {
    if (this.gridApi) {
      let lastRowIndex = this.gridApi.getDisplayedRowCount() - 1;
      this.gridApi.ensureIndexVisible(lastRowIndex, 'bottom');
    }
  }
  goFirstRow() {
    if (this.gridApi) {
      this.gridApi.ensureIndexVisible(0, 'top');
    }
  }
  onSumAll(itemList: any[], columnDefs: ColDef[]): string {
    if (itemList.length === 0) return '';
    let sumItem: any = {};
    jkLib.cloneField(itemList[itemList.length - 1], sumItem);
    for (let i = 0; i < columnDefs.length; i++) {
      let col = columnDefs[i];
      if (col.cellDataType === 'number') {
        let sum = 0;
        let field = col.field;
        for (let j = 0; j < itemList.length; j++) {
          let item = itemList[j];
          sum += item[field as any];
        }
        if (field)
          sumItem[field] = jkLib.fourOutFiveIn(sum, 4);
      }
    }
    let fieldNames: string[] = [];
    let headerName: string[] = [];
    for (let i = 0; i < columnDefs.length; i++) {
      let col = columnDefs[i];
      if (col.cellDataType === 'number') {
        fieldNames.push(col.field as any);
        headerName.push(col.headerName as any);
      };
    };
    /*
    sumItem[columnDefs[0].field as any] = '總計';
    itemList.push(sumItem);
    //this.pageSrv.getPager(this._itemList);
    let tmpList = itemList;
    itemList = [];
    itemList = tmpList; // TODO: 仍顯示不出來 這樣才會重新 render
    this.refresh();
    */
    let display: string = '總計:';
    for (let i = 0; i < fieldNames.length; i++) {
      display += `${headerName[i]}:${sumItem[fieldNames[i]]} ` + CR;
    }
    //doTextArea(display,'總計');
    return display;
  }
  // 搜尋功能實作
  searchGrid(value: string, columnDefs: ColDef[], cdr: ChangeDetectorRef) {
    if (!value) return;
    value = value.trim();
    let foundCell: any = undefined;

    // 遍歷所有列
    this.gridApi.forEachNode((node, index) => {
      // 遍歷該列的所有欄位
      columnDefs.forEach((column) => {
        if (column.cellDataType === 'number') return;
        if (column.cellDataType === 'date') return;
        if (column.cellDataType === 'object') return;
        const cellValue = node.data[column.field as any]?.toString();
        if (cellValue && cellValue.includes(value)) {
          foundCell = {
            rowIndex: index,
            column: column.field,
          };
          return;
        }
      });
    });

    // 如果找到符合的欄位
    if (foundCell) {
      // 選取該列
      this.gridApi.getRowNode(foundCell.rowIndex)?.setSelected(true);

      // 捲動到該欄位
      this.gridApi.ensureIndexVisible(foundCell.rowIndex);

      // 設定焦點到該欄位
      setTimeout(() => {
        this.gridApi.setFocusedCell(foundCell.rowIndex, foundCell.column);
        // 手動觸發變更檢測以符合 zoneless 模式
        cdr.markForCheck();
      }, 100);
    } else {
      alert('找不到符合的資料:'+value);
    }
  }
  /**
   * 搜尋指定欄位的值 未測試
   * @param value 搜尋值
   * @param seekFields 搜尋欄位,多欄位用逗號分隔
   * @returns
   */
  seek(value: string, seekFields: string) {
    if (!value) return;
    value = value.trim();
    let fieldList = seekFields.split(',');
    if (this.gridApi) {
      // 使用 forEachNode 遍歷所有節點

      this.gridApi.forEachNode((node) => {
        fieldList.forEach((field) => {
          if (node.data[field] === value) {
            // 假設每行資料有一個 'id' 屬性
            // 確保找到的節點在視圖中可見
            if (node.rowIndex)
              this.gridApi.ensureIndexVisible(node.rowIndex);

            // （可選）選擇該節點
            node.setSelected(true);
          }
        });
      });
    };
  }

  setFieldLengths(cols: ColDef[], fieldLengths: any) {
    this.fieldLengths = fieldLengths;
    if (!fieldLengths) return;
    cols.forEach((col) => {
      let field = col.field;
      if (field) {
        let len = fieldLengths[field];
        if ((len > 10) && (col.cellDataType === 'text')) {
          col.tooltipField = field;
        }
      }
    });

  }
}
